export default __webpack_public_path__ + "static/media/VERSE.a3a3d48f.png";